<template>
  <div>
    <a-table v-if="dataSource" style="width: 800px" size="small" :pagination="false" :columns="columns" row-key="workflow_id" :data-source="dataSource">
      <span slot="customStatus" slot-scope="text, record">
        <a-badge :status="workflowStatus[record.workflow_status].status" :text="workflowStatus[record.workflow_status].label" />
      </span>
      <span slot="customTitle" slot-scope="text, record">
        <a class="custom-title" :href="link(record)" target="_blank">{{ record.workflow_title }}</a>
      </span>
    </a-table>
  </div>
</template>
<script>
import { workflowStatus } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    width: 60,
    dataIndex: 'workflow_id'
  },
  {
    title: '标题',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '镜像版本',
    width: 140,
    ellipsis: true,
    dataIndex: 'artifact_version'
  },
  {
    title: '状态',
    width: 100,
    scopedSlots: { customRender: 'customStatus' }
  },
  {
    title: '当前步骤',
    dataIndex: 'workflow_current_step',
    key: 'workflow_current_step',
    width: 120,
    ellipsis: true
  }
];

export default {
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      workflowStatus
    };
  },
  computed: {
    link() {
      return record => {
        if (record) {
          return this.$router.resolve({
            name: 'page:project:workflow:detail',
            params: { project_id: record.project_id },
            query: { workflowId: record.workflow_id }
          }).href;
        } else {
          return '';
        }
      };
    }
  },
  created() {
    console.log(this.dataSource);
  }
};
</script>

<style lang="less" scoped>
.custom-title {
  color: rgba(0, 0, 0, 0.65);
}
.custom-title:hover {
  cursor: pointer;
  color: #1890ff;
}
</style>
